<template>
    <b-card title="Payments History Statement">
        <b-table :items="items" :fields="fields">
            <template v-slot:cell(for_care_week)="data">
                {{ formatDate(data.item.week.start) }} - {{ formatDate(data.item.week.end) }}
            </template>
            <template v-slot:cell(actions)="data">
                <b-btn :href="'/business/clients/payments/'+data.item.id">View Details</b-btn>
            </template>
        </b-table>
    </b-card>
</template>

<script>
    import FormatsDates from '../../../mixins/FormatsDates';
    import FormatsNumbers from '../../../mixins/FormatsNumbers';

    export default {
        props: ['payments'],
        
        mixins: [FormatsDates, FormatsNumbers],
        
        data() {
            return{
                items: this.payments,
                fields: [
                    {
                        key: 'created_at',
                        label: 'Paid',
                        formatter: (value) => { return this.formatDate(value) }
                    },
                    'for_care_week',
                    {
                        key: 'amount',
                        formatter: (value) => { return this.moneyFormat(value) }
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print'
                    }
                ]
            }
        },
        
        created() {
        
        },
        
        mounted() {
        
        },
        
        methods: {
        
        },
        
        computed: {
        
        }
    }
</script>